import { LOAN_DEFERMENT } from "../../constants/admin/masterdata/constants";

const initialState = {
  isModalAction: false,
  loadingActionLoanDeferment: false,
  selectedIds: [],
  queryKey: null,
};

export const loanDefermentReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAN_DEFERMENT.LOADING_ACTION:
      return { ...state, loadingActionLoanDeferment: action.load };

    case LOAN_DEFERMENT.IS_MODAL_ACTION:
      return { ...state, isModalAction: action.load };

    case LOAN_DEFERMENT.SET_QUERY_KEY: {
      if (state.queryKey !== action.key) {
        return { ...state, queryKey: action.key, selectedIds: [] };
      }
      return state;
    }

    case LOAN_DEFERMENT.ADD_SELECTED_IDS: {
      const set = new Set(state.selectedIds);
      (action.ids || []).forEach((id) => set.add(id));
      return { ...state, selectedIds: Array.from(set) };
    }

    case LOAN_DEFERMENT.REMOVE_SELECTED_IDS: {
      const removeSet = new Set(action.ids || []);
      const next = state.selectedIds.filter((id) => !removeSet.has(id));
      return { ...state, selectedIds: next };
    }

    case LOAN_DEFERMENT.CLEAR_SELECTED_IDS:
      return { ...state, selectedIds: [] };

    default:
      return state;
  }
};